import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import RequestQuoteRoundedIcon from "@mui/icons-material/RequestQuoteRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import LayersRoundedIcon from "@mui/icons-material/LayersRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import QuizRoundedIcon from "@mui/icons-material/QuizRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import { SvgIconComponent } from "@mui/icons-material";

export interface AdminNavItem {
  label: string;
  to: string;
  icon: SvgIconComponent;
}

export const adminNavItems: AdminNavItem[] = [
  { label: "Dashboard", to: "/admin/dashboard", icon: DashboardRoundedIcon },
  { label: "Quotations", to: "/admin/quotations", icon: DescriptionRoundedIcon },
  { label: "Custom Quotations", to: "/admin/custom-quotations", icon: RequestQuoteRoundedIcon },
  { label: "Customers", to: "/admin/customers", icon: PeopleAltRoundedIcon },
  { label: "Events", to: "/admin/events", icon: EventRoundedIcon },
  { label: "Templates", to: "/admin/templates", icon: LayersRoundedIcon },
  { label: "Item Master", to: "/admin/catalog", icon: Inventory2RoundedIcon },
  { label: "Categories", to: "/admin/categories", icon: CategoryRoundedIcon },
  { label: "Custom Questions", to: "/admin/custom-questions", icon: QuizRoundedIcon },
  { label: "Users", to: "/admin/users", icon: AdminPanelSettingsRoundedIcon },
  { label: "Reports", to: "/admin/reports", icon: BarChartRoundedIcon }
];
